import { useEffect, useState } from "react";
import "@/App.css";
import { ThemeProvider } from "@/context/ThemeContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Outcomes, HealthcareTeaser, ScannerSection } from "@/components/HomeIntro";
import { Challenges } from "@/components/Challenges";
import { Services } from "@/components/Services";
import { WhyEasilinked } from "@/components/WhyEasilinked";
import { Approach } from "@/components/Approach";
import { CTA } from "@/components/CTA";
import { Footer } from "@/components/Footer";
import { BookDialog } from "@/components/BookDialog";
import { Analytics } from "@/components/Analytics";
import { useSeo } from "@/lib/useSeo";
import { getHomepageSeo } from "@/lib/sanityQueries";
import { peek } from "@/lib/sanity";

function App() {
    const [booking, setBooking] = useState(false);
    const [seo, setSeo] = useState(() => peek(getHomepageSeo)?.seo ?? null);
    const openBooking = () => setBooking(true);

    useEffect(() => {
        let active = true;
        getHomepageSeo()
            .then((data) => {
                if (active && data?.seo) setSeo(data.seo);
            })
            .catch(() => {});
        return () => {
            active = false;
        };
    }, []);

    useSeo(seo);


    return (
        <ThemeProvider>
            <div className="min-h-screen bg-brand-bg font-body text-brand-text antialiased">
                <Navbar />
                <main>
                    <Hero />
                    <Outcomes />
                    <HealthcareTeaser />
                    <Services />
                    <ScannerSection />
                    <Challenges />
                    <WhyEasilinked />
                    <Approach />
                    <CTA onBook={openBooking} />
                </main>
                <Footer />
                <BookDialog open={booking} onClose={() => setBooking(false)} />
                <Analytics />
            </div>
        </ThemeProvider>
    );
}

export default App;
